/**
 * Çöp Chatleri temizler
 * 5.sn bir temizlik işini başlatır
 * Chat kapanmış ve 1dk yı geçmişse artık çöptür bu çöpler bu worker tarafından toplanır
 */

import { interval, from } from "rxjs";
import { map, filter, switchMap, tap, bufferTime } from "rxjs/operators";
import chat from "../store/modules/chat";
import store from "@/store";
import log2 from "../utils/log2";
import { systemMessageStream } from "../utils/systemPubSub";

const log = log2("GarbageChatCollect");
const getAllConservation = () => {
    return chat.state.conversations;
};
const isActiveChat = (id) => {
    return chat.state.activeConversation && chat.state.activeConversation._id === id;
};
const deleteConservation = (id) => {
    log("deleting", { id });
    store.dispatch("chat/removeConversation", id);
};

export const garbageChatCollector = () => {
    log.info("garbageChatCollector running");

    return interval(3000)
        .pipe(
            //tap(x => log("step 1", x)),
            map((x) => getAllConservation()),
            //tap(x => log("step 2", x)),
            switchMap((arr) => from(arr)),
            //tap(x => log("step 3", x)),
            filter((chat) => chat.status === "destroyed"),
            //tap(x => log("step 4", x)),
            filter((chat) => !isActiveChat(chat._id)),
            //tap(x => log("step 5", x)),
            map((chat) => {
                if (!chat.destroyedDate) chat.destroyedDate = new Date(Date.now() - 1000 * 60 * 2); //eğer destroyedDate set edilmemişse ekliyoruz. 2dk öncesi gibi
                return chat;
            }),
            filter((chat) => chat.destroyedDate),
            filter((chat) => Date.now() - new Date(chat.destroyedDate).getTime() > 1000 * 30)
            //tap(x => log("step last", x)),
        )
        .subscribe((chat) => {
            deleteConservation(chat._id);
        });
};
